import React, { useState, useEffect } from "react";
import { Redirect, Route, Link } from "react-router-dom";

import api from "../services/api";

export default function AMLPolicy(props) {
  const [pageContent, setPageContent] = useState("");
  const getContentPage = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "aml_policy",
    });

    if (response.status == 200) {
      setPageContent(response.data);
    }
  };

  useEffect(() => {
    getContentPage();
  }, []);
  const renderHTML = (rawHTML: string) =>
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: rawHTML },
    });

  return (
    <>
      <div class="container-xxl">
        <section className="contentPage">
          <div className="pageTitle">
            {pageContent && pageContent.content_data.page_title}
          </div>
          <div className="paragraph">
            {pageContent && renderHTML(pageContent.content_data.content)}
          </div>
        </section>

        <section className="contentPage d-none">
          <div className="pageTitle">
            <h1>AML / KYC Policy</h1>
          </div>
          <div className="paragraph">
            <p>
              <strong>Last updated:</strong> March 03, 2025
            </p>

            <h2>Introduction</h2>
            <p>
              <a href="http://www.chilirojo.com">www.chilirojo.com</a> is
              operated by ChapChap Technologies Ltd., a limited liability
              company registered in Island of Anjouan, Comoros with company
              registration number 15788, with registered address at Hamchako
              Mutsamudu, The Autonomous Island of Anjouan, Union of Comoros.
              chilirojo is licensed in the State of Anjouan under the Computer
              Gaming Licensing Act 007 of 2005 under License No.
              ALSI-202409025-FI2.
            </p>

            <h2>Objective of the AML Policy</h2>
            <p>
              We seek to offer the highest security to all of our users and
              customers on{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a>. For this
              purpose, a three-step account verification process is implemented
              to ensure the identity of our customers. The goal is to verify
              that the details of the registered person are correct and that the
              deposit methods used are not stolen or being used by someone else.
              This creates the general framework for the fight against money
              laundering. We also consider that, depending on nationality and
              origin, different safety measures must be taken for payment and
              withdrawal methods.
            </p>
            <p>
              chilirojo.com also implements reasonable measures to control and
              limit money laundering (ML) risks, including dedicating
              appropriate resources.
            </p>
            <p>
              chilirojo.com is committed to high standards of anti-money
              laundering (AML) according to EU guidelines and compliance
              requirements. Management and employees are required to enforce
              these standards to prevent the use of its services for money
              laundering purposes.
            </p>
            <p>
              The AML program of chilirojo.com is designed to be compliant with:
            </p>
            <ul>
              <li>
                EU: “Directive 2015/849 of the European Parliament and of The
                Council of 20 May 2015 on the prevention of the use of the
                financial system for the purposes of money laundering.”
              </li>
              <li>
                EU: “Regulation 2015/847 on information accompanying transfers
                of funds.”
              </li>
              <li>
                EU: Various regulations imposing sanctions or restrictive
                measures against persons and embargo on certain goods and
                technology, including all dual-use goods.
              </li>
              <li>
                BE: “Law of 18 September 2017 on the prevention of money
                laundering limitation of the use of cash.”
              </li>
            </ul>

            <h2>Definition of Money Laundering</h2>
            <p>Money Laundering is understood as:</p>
            <ul>
              <li>
                The conversion or transfer of property, especially money,
                knowing that such property is derived from criminal activity or
                from taking part in such activity, for the purpose of concealing
                or disguising the illegal origin of the property or of helping
                any person who is involved in the commission of such an activity
                to evade the legal consequences of that person's or companies’
                action.
              </li>
              <li>
                The concealment or disguise of the true nature, source,
                location, disposition, movement, rights with respect to, or
                ownership of, property, knowing that such property is derived
                from criminal activity or from an act of participation in such
                an activity.
              </li>
              <li>
                The acquisition, possession or use of property, knowing, at the
                time of receipt, that such property was derived from criminal
                activity or from assisting in such an activity.
              </li>
              <li>
                Participation in, association to commit, attempts to commit and
                aiding, abetting, facilitating and counselling the commission of
                any of the actions referred to in the points above.
              </li>
            </ul>
            <p>
              Money laundering shall be regarded as such even when the
              activities which generated the property to be laundered were
              carried out in the territory of another Member State or in that of
              a third country.
            </p>

            <h2>Organization of the AML for chilirojo.com</h2>
            <p>
              In accordance with AML legislation, chilirojo.com has appointed
              the “highest level” for the prevention of ML: The full management
              of our company is in charge.
            </p>
            <p>
              Furthermore, an AMLCO (Anti-Money Laundering Compliance Officer)
              is in charge of the enforcement of the AML policy and procedures
              within the system. The AMLCO is placed under the direct
              responsibility of the general management.
            </p>
            <p>AML policy changes and implementation requirements:</p>
            <p>
              Each major change of chilirojo.com’s AML policy is subject to
              approval by the general management of our Company and the
              Anti-Money Laundering Compliance Officer.
            </p>

            <h2>Three-Step Verification</h2>
            <h3>Step One Verification</h3>
            <p>
              Step one verification must be done by every user and customer to
              withdraw. Regardless of the choice of payment, the amount of
              payment, the amount of withdrawal, the choice of withdrawal, and
              the nationality of the user/customer, step one verification must
              be completed first. Step one verification is a document that must
              be filled out by the user/customer themselves. The following
              information must be provided:
            </p>
            <ul>
              <li>First name</li>
              <li>Second name</li>
              <li>Date of birth</li>
              <li>Country of usual residence</li>
              <li>Gender</li>
              <li>Full address</li>
            </ul>

            <h3>Step Two Verification</h3>
            <p>
              Step two verification must be done by every user who deposits over
              US $2,000 (or crypto equivalent), withdraws over US $2,000 (or
              crypto equivalent), or sends another user over US $1,000 (or
              crypto equivalent). Until step two verification is completed, the
              withdrawal, tip, or deposit will be held. Step two verification
              will lead the user or customer to a subpage where they must submit
              their ID. The user/customer must take a picture of their ID with a
              paperclip displaying a six-digit random-generated number next to
              it. Only an official ID may be used for ID verification, depending
              on the country. There will also be an electronic check to ensure
              the data from step one verification is correct. The electronic
              check will verify the information via two different databases. If
              the electronic test fails or is not possible, the user/customer is
              required to submit proof of their current residence, such as a
              certificate of registration by the government or a similar
              document.
            </p>

            <h3>Step Three Verification</h3>
            <p>
              Step three verification must be done by every user who deposits
              over EUR/US $5,000 (or crypto equivalent), withdraws over EUR/US
              $5,000 (or crypto equivalent), or sends another user over EUR/US
              $3,000 (or crypto equivalent). Until step three verification is
              completed, the withdrawal, tip, or deposit will be held. For step
              three, a user/customer will be asked to provide a source of
              wealth.
            </p>

            <h2>Customer Identification and Verification (KYC)</h2>
            <p>
              The formal identification of customers upon entering into
              commercial relations is a vital element of both AML regulations
              and the KYC policy. This identification relies on the following
              fundamental principles:
            </p>
            <ul>
              <li>
                A copy of your passport, ID card, or driving license, each shown
                alongside a handwritten note mentioning six random-generated
                numbers. A second picture of the user/customer's face is also
                required. The user/customer may blur out all information except
                date of birth, nationality, gender, first name, second name, and
                the picture to secure their privacy.
              </li>
              <li>
                Please note that all four corners of the ID must be visible in
                the same image, and all details must be clearly readable. We may
                ask for all details if necessary.
              </li>
              <li>
                An employee may conduct additional checks if necessary, based on
                the situation.
              </li>
            </ul>

            <h3>Proof of Address</h3>
            <p>
              Proof of address will be verified via two different electronic
              checks using two different databases. If an electronic test fails,
              the user/customer has the option to provide manual proof. A recent
              utility bill sent to your registered address, issued within the
              last three months, or an official government document proving your
              state of residence is required. To ensure a speedy approval
              process, please ensure the document is sent with a clear
              resolution where all four corners of the document are visible, and
              all text is readable. Examples include an electricity bill, water
              bill, bank statement, or any governmental post addressed to you.
              An employee may conduct additional checks if necessary, based on
              the situation.
            </p>

            <h3>Source of Funds</h3>
            <p>
              If a player deposits over five thousand US Dollars, there is a
              process of understanding the source of wealth (SOW). Examples of
              SOW include:
            </p>
            <ul>
              <li>Ownership of a business</li>
              <li>Employment</li>
              <li>Inheritance</li>
              <li>Investment</li>
              <li>Family</li>
            </ul>
            <p>
              It is critical that the origin and legitimacy of that wealth are
              clearly understood. If this is not possible, an employee may ask
              for additional documents or proof. The account will be frozen if
              the same user deposits this amount in one go or through multiple
              transactions amounting to this. An email will be sent to them
              manually to go through the above process, and information will be
              provided on the website itself.
            </p>
            <p>
              <a href="http://www.chilirojo.com">www.chilirojo.com</a> also asks
              for a bank wire/credit card to further ensure the identity of the
              user/customer. It also provides additional information about the
              financial situation of the user/customer.
            </p>

            <h3>Basic Document for Step One</h3>
            <p>
              The basic document will be accessible via the settings page on{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a>. Every
              user must fill out the following information:
            </p>
            <ul>
              <li>First name</li>
              <li>Second name</li>
              <li>Nationality</li>
              <li>Gender</li>
              <li>Date of Birth</li>
            </ul>
            <p>
              The document will be saved and created by an AI. An employee may
              conduct additional checks if necessary, based on the situation.
            </p>

            <h2>Risk Management</h2>
            <p>
              To address the different risks and varying states of wealth in
              different regions, chilirojo.com categorizes every nation into
              three different risk regions:
            </p>
            <ul>
              <li>
                <strong>Region One: Low Risk</strong> - For every nation in this
                region, the three-step verification is done as described
                earlier.
              </li>
              <li>
                <strong>Region Two: Medium Risk</strong> - For every nation in
                this region, the three-step verification will be done at lower
                deposit, withdrawal, and tip amounts. Step one will be done as
                usual. Step two will be done after depositing US $1,000 (or
                crypto equivalent) or tipping another user/customer US $500 (or
                crypto equivalent). Step three will be done after depositing US
                $2,500 (or crypto equivalent), withdrawing US $2,500 (or crypto
                equivalent), or tipping another user/customer US $1,000 (or
                crypto equivalent). Users from a low-risk region who change
                cryptocurrency into any other currency will be treated like
                users/customers from a medium-risk region.
              </li>
              <li>
                <strong>Region Three: High Risk</strong> - Regions of high risk
                will be banned. High-risk regions will be regularly updated to
                keep up with the changing environment of a fast-changing world.
              </li>
            </ul>

            <h2>Additional Measures</h2>
            <p>
              In addition, an AI overseen by the AML Compliance Officer will
              monitor for any unusual behavior and report it immediately to an
              employee of{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a>.
            </p>
            <p>
              Based on a risk-based and general experience, human employees will
              recheck all checks done by the AI or other employees and may redo
              or conduct additional checks as necessary.
            </p>
            <p>
              Additionally, a data scientist supported by modern, electronic,
              analytic systems will look for unusual behavior, such as:
            </p>
            <ul>
              <li>
                Depositing and withdrawing without longer betting sessions.
              </li>
              <li>
                Attempts to use a different bank account for deposit and
                withdrawal.
              </li>
              <li>Nationality changes.</li>
              <li>Currency changes.</li>
              <li>Behavior and activity changes.</li>
              <li>
                Checks to ensure an account is used by its original owner.
              </li>
            </ul>
            <p>
              Also, a user must use the same method for withdrawal as they used
              for deposit, for the amount of the initial deposit, to prevent
              money laundering.
            </p>

            <h2>Enterprise-Wide Risk Assessment</h2>
            <p>
              As part of its risk-based approach,{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a> has
              conducted an AML “Enterprise-wide risk assessment” (EWRA) to
              identify and understand risks specific to its business lines. The
              AML risk policy is determined after identifying and documenting
              the risks inherent to its business lines, such as the services the
              website offers, the users to whom services are offered,
              transactions performed by these users, delivery channels used by
              the bank, the geographic locations of the bank’s operations,
              customers and transactions, and other qualitative and emerging
              risks.
            </p>
            <p>
              The identification of AML risk categories is based on{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a>'s
              understanding of regulatory requirements, regulatory expectations,
              and industry guidance. Additional safety measures are taken to
              address the additional risks the worldwide web brings with it.
            </p>
            <p>The EWRA is reassessed yearly.</p>

            <h2>Ongoing Transaction Monitoring</h2>
            <p>
              AML-Compliance ensures that an “ongoing transaction monitoring” is
              conducted to detect transactions that are unusual or suspicious
              compared to the customer profile. This transaction monitoring is
              conducted on two levels:
            </p>
            <ol>
              <li>
                <strong>The First Line of Control:</strong> chilirojo.com works
                solely with trusted Payment Service Providers who all have
                effective AML policies in place to prevent the majority of
                suspicious deposits onto{" "}
                <a href="http://www.chilirojo.com">www.chilirojo.com</a> without
                proper execution of KYC procedures on the potential customer.
              </li>
              <li>
                <strong>The Second Line of Control:</strong> chilirojo.com
                ensures its network is aware so that any contact with the
                customer, player, or authorized representative must give rise to
                the exercise of due diligence on transactions on the account
                concerned. This includes:
                <ul>
                  <li>
                    Requests for the execution of financial transactions on the
                    account.
                  </li>
                  <li>
                    Requests in relation to means of payment or services on the
                    account.
                  </li>
                </ul>
                <p>
                  Additionally, the three-step verification with adjusted risk
                  management should provide all necessary information about all
                  customers of{" "}
                  <a href="http://www.chilirojo.com">www.chilirojo.com</a> at
                  all times. All transactions must be overseen by employees,
                  supervised by the AML Compliance Officer, who is overseen by
                  the general management.
                </p>
                <p>
                  The specific transactions submitted to the customer support
                  manager, possibly through their Compliance Manager, must also
                  be subject to due diligence. The determination of the unusual
                  nature of one or more transactions depends on a subjective
                  assessment, in relation to the knowledge of the customer
                  (KYC), their financial behavior, and the transaction
                  counterparty.
                </p>
                <p>
                  These checks will be done by an automated system, while an
                  employee cross-checks them for additional security.
                  Transactions observed on customer accounts for which it is
                  difficult to gain a proper understanding of the lawful
                  activities and origin of funds must be considered atypical (as
                  they are not directly justifiable).
                </p>
                <p>
                  Any chilirojo.com staff member must inform the AML division of
                  any atypical transactions they observe and cannot attribute to
                  a lawful activity or source of income known of the customer.
                </p>
              </li>
              <li>
                <strong>The Third Line of Control:</strong> As a last line of
                defense against AML,{" "}
                <a href="http://www.chilirojo.com">www.chilirojo.com</a> will
                conduct manual checks on all suspicious and higher-risk users to
                fully prevent money laundering. If fraud or money laundering is
                found, the authorities will be informed.
              </li>
            </ol>

            <h2>Reporting of Suspicious Transactions on chilirojo.com</h2>
            <p>
              In its internal procedures,{" "}
              <a href="http://www.chilirojo.com">www.chilirojo.com</a> describes
              in precise terms, for the attention of its staff members, when it
              is necessary to report and how to proceed with such reporting.
              Reports of atypical transactions are analyzed within the AML team
              in accordance with the precise methodology fully described in the
              internal procedures.
            </p>
            <p>
              Depending on the result of this examination and on the basis of
              the information gathered, the AML team:
            </p>
            <ul>
              <li>
                Will decide whether it is necessary or not to send a report to
                the FIU, in accordance with the legal obligations provided in
                the Law of 18 September 2017.
              </li>
              <li>
                Will decide whether or not it is necessary to terminate the
                business relationship with the customer.
              </li>
            </ul>

            <h2>Procedures</h2>
            <p>
              The AML rules, including minimum KYC standards, will be translated
              into operational guidance or procedures that are available on the
              Intranet site of chilirojo.com.
            </p>

            <h2>Record Keeping</h2>
            <p>
              Records of data obtained for the purpose of identification must be
              kept for at least ten years after the business relationship has
              ended. Records of all transaction data must be kept for at least
              ten years following the carrying-out of the transactions or the
              end of the business relationship. These data will be securely and
              encrypted, stored offline and online.
            </p>

            <h2>Training</h2>
            <p>
              <a href="http://www.chilirojo.com">www.chilirojo.com</a> human
              employees will conduct manual controls on a risk-based approval
              process for which they receive special training. The training and
              awareness program is reflected by its usage:
            </p>
            <ul>
              <li>
                A mandatory AML training program in accordance with the latest
                regulatory evolutions, for all employees in touch with finances.
              </li>
              <li>Academic AML learning sessions for all new employees.</li>
            </ul>
            <p>
              The content of this training program is established in accordance
              with the kind of business the trainees are working for and the
              posts they hold. These sessions are given by an AML specialist
              working in our company’s team.
            </p>

            <h2>Auditing</h2>
            <p>
              Internal audit regularly establishes missions and reports about
              AML activities.
            </p>

            <h2>Data Security</h2>
            <p>
              All data provided by any user/customer will be kept secure, will
              not be sold or given to anyone else. Only if forced by law or to
              prevent money laundering may data be shared with the AML authority
              of the affected state. chilirojo.com will follow all guidelines
              and rules of the Data Protection Directive (officially Directive
              95/46/EC).
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have any questions or complaints about our AML and KYC
              Policy, please contact us:
            </p>
            <p>
              <strong>By email:</strong>{" "}
              <a href="mailto:support@chilirojo.com">support@chilirojo.com</a>
            </p>
          </div>
        </section>
      </div>
    </>
  );
}
